import { convertLoadText, normalizeUnit } from './units';

/**
 * Group consecutive sets with same reps/weight for display (e.g. 2×3@5kg, 2×2@5kg).
 * @param {Array} sets - exercise.sets
 * @param {boolean} useRir - exercise.useRir (RPE mode : `weight` est un RPE, jamais converti)
 * @param {{ fromUnit?: string, toUnit?: string }} [units] - unité de saisie des charges
 *   (`exercise.unit`, absent → kg) et unité d'affichage. Même unité → valeurs intactes.
 * @returns {Array<{ count: number, reps: string|number, weight: number|string }>}
 */
function orZero(v) {
  return (v != null && v !== '') ? v : 0;
}

export function getSetGroups(sets, useRir = false, { fromUnit, toUnit } = {}) {
  if (!sets || sets.length === 0) return [];
  const convert = !useRir && toUnit != null && normalizeUnit(fromUnit) !== normalizeUnit(toUnit);
  const weightOf = (s) => {
    const w = orZero(s?.weight);
    return convert ? convertLoadText(w, fromUnit, toUnit) : w;
  };
  const groups = [];
  let current = { count: 1, reps: orZero(sets[0]?.reps), weight: weightOf(sets[0]) };
  for (let i = 1; i < sets.length; i++) {
    const s = sets[i];
    const reps = orZero(s?.reps);
    const weight = weightOf(s);
    if (String(reps) === String(current.reps) && String(weight) === String(current.weight)) {
      current.count++;
    } else {
      groups.push(current);
      current = { count: 1, reps, weight };
    }
  }
  groups.push(current);
  return groups;
}
